import Card from "../ui/card/Card";
import moment from "moment-timezone";
import Accordion from "../ui/Accordion";
import React from "react";

const timezone = 'Asia/Kolkata';
const CustomerTransactionCard=({item})=>{
    return(
            <Card className="mb-3 shadow-sm border-0 rounded-3">
                {/* Top Row: Date & Status */}
                <div className="d-flex justify-content-between align-items-center">
                    <p className="fs-sm mb-0 text-muted">
                        Pay At:{" "}
                        <span className="fw-semibold">{moment(item.payAt)
                            .tz(timezone)
                            .format("ddd, MMM DD, YYYY, hh:mm A")}
                        </span>
                    </p>
                    {/*Payment Method*/}
                    <span
                        className="badge px-3 py-2 rounded-pill bg-success bg-opacity-25 text-body fw-semibold">
                               Payment Method: {item.paymentMethod}
                    </span>
                </div>

                <hr className="my-2"/>

                {/*Accordion*/}
                <Accordion buttonClasses="p-2">
                    <Accordion.Header>
                        Orders ({item.orders.length})
                    </Accordion.Header>
                    <Accordion.Body>
                        {item.orders.map((order, oIndex) => (
                            <div key={oIndex} className="mb-1">
                                <div className="d-flex justify-content-between ps-3">
                                    <span className="fw-medium fs-md"> Order #{order.orderNo}</span>
                                    <span className="fw-semibold fs-md text-secondary">
                                      ₹ {order.amount}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </Accordion.Body>
                </Accordion>

                {/* Total */}
                <div className="d-flex justify-content-between align-items-center px-2 mt-2">
                    <span className="fw-semibold fs-md">Amount Paid</span>
                    <span className="fw-bold fs-md text-success">
                        ₹ {item.totalAmount}
                    </span>
                </div>
            </Card>
    )
}

export default CustomerTransactionCard;